import axios from 'axios';
import { URL_PATHS } from '../constants/api.constants';
import {
  LoginPayload,
  LoginResponse,
  RecoverPasswordPayload,
  RegisterUserPayload,
  ResetPasswordPayload,
  VerifyTokenResponse,
} from '../types/auth.type';

const login = (credentials: LoginPayload): Promise<LoginResponse> => {
  return axios.post(`${URL_PATHS.API_AUTH_V1}/login`, credentials);
};

const refreshToken = (token: string): Promise<LoginResponse> => {
  const bodyData = { token };
  return axios.post(`${URL_PATHS.API_AUTH_V1}/refreshToken`, bodyData);
};

const recoverPassword = (data: RecoverPasswordPayload) => {
  return axios.post(`${URL_PATHS.API_AUTH_V1}/forgotPassword`, data);
};

const registerUser = (data: RegisterUserPayload): Promise<LoginResponse> => {
  return axios.post(`${URL_PATHS.API_AUTH_V1}/register`, data);
};

const verifyJwt = (): Promise<VerifyTokenResponse> => {
  return axios.get(`${URL_PATHS.API_AUTH_V1}/verifyJwt`);
};

const resetPassword = (data: ResetPasswordPayload) => {
  return axios.post(`${URL_PATHS.API_AUTH_V1}/recoverPassword`, data);
};

const AuthService = {
  login,
  refreshToken,
  recoverPassword,
  registerUser,
  verifyJwt,
  resetPassword,
};

export default AuthService;
